"use strict";
'use client';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTotalJackpotsFlexInterval = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var axios_1 = __importDefault(require("axios"));
var currencies_1 = require("../currencies");
var SUCCESS_INTERVAL = 5000;
var useTotalJackpotsFlexInterval = function () {
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var _a = (0, react_1.useState)(undefined), preparedData = _a[0], setPreparedData = _a[1];
    var intervalTime = (0, react_1.useRef)(SUCCESS_INTERVAL);
    var currentInterval = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (!currentCurrency)
            return;
        currentInterval.current = setInterval(function () { return __awaiter(void 0, void 0, void 0, function () {
            var res, newAmount, existedAmount, err_1;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.post("".concat(window.location.origin).concat(keys_1.JACKPOT_TOTAL), {
                                currency: currentCurrency,
                            })];
                    case 1:
                        res = _f.sent();
                        if (intervalTime.current !== SUCCESS_INTERVAL)
                            intervalTime.current = SUCCESS_INTERVAL;
                        newAmount = Number((_c = (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.jackpot) === null || _b === void 0 ? void 0 : _b.jackpotResult) === null || _c === void 0 ? void 0 : _c.currentAmount) || 0;
                        existedAmount = Number((_e = (_d = preparedData === null || preparedData === void 0 ? void 0 : preparedData.jackpot) === null || _d === void 0 ? void 0 : _d.jackpotResult) === null || _e === void 0 ? void 0 : _e.currentAmount) || 0;
                        if ((res === null || res === void 0 ? void 0 : res.data) && newAmount !== existedAmount) {
                            setPreparedData(res === null || res === void 0 ? void 0 : res.data);
                        }
                        if (intervalTime.current != SUCCESS_INTERVAL)
                            intervalTime.current = SUCCESS_INTERVAL;
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _f.sent();
                        clearInterval(currentInterval.current);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); }, intervalTime.current);
        return function () {
            clearInterval(currentInterval.current);
        };
    }, [currentCurrency, preparedData]);
    return (0, react_1.useMemo)(function () {
        return { data: preparedData };
    }, [preparedData]);
};
exports.useTotalJackpotsFlexInterval = useTotalJackpotsFlexInterval;
